const mailChimpApiKey="https://dolphinflashcards.us18.list-manage.com/subscribe/post?u=912e840a9d7addf77060a3290&amp;id=2636de219f&amp;f_id=009fc2e1f0"; export default mailChimpApiKey;
